export const hero = {
  "title": "Échangez entre hôtes,",
  "titleHighlight": "partout en Europe",
  "subtitle": "Club d'échange européen réservé aux hôtes Airbnb notés 4,5+ avec abonnement unique Europe.",
  "cta": "Commencer l'échange",
  "learnMore": "En savoir plus",
  "stats": {
    "owners": "Propriétaires actifs",
    "countries": "Pays disponibles",
    "exchanges": "Échanges réalisés"
  },
  "slogans": {
    "slogan1": {
      "title": "Club privé",
      "highlight": "hôtes Airbnb 4,5+",
      "subtitle": "Un accès réservé aux hôtes bien notés pour échanger dans un cadre de confiance."
    },
    "slogan2": {
      "title": "Offre lancement 2026",
      "highlight": "-50% pour les 1000 premiers",
      "subtitle": "25EUR/an au lieu de 50EUR/an, avec prix garanti à vie."
    },
    "slogan3": {
      "title": "Prix garanti à vie",
      "highlight": "1000 premiers membres",
      "subtitle": "Les 1000 premiers inscrits conservent leur tarif à vie."
    },
    "slogan4": {
      "title": "Pas d'intermédiaires,",
      "highlight": "juste du lien",
      "subtitle": "Une communauté de confiance où l'on échange des séjours, pas des nuitées vendues."
    },
    "slogan5": {
      "title": "Rejoignez le club",
      "highlight": "DONKEY TRAVEL",
      "subtitle": "Le club d'échange pensé pour les hôtes Airbnb actifs en Europe."
    },
    "slogan6": {
      "title": "Basse saison",
      "highlight": "optimisée",
      "subtitle": "Transformez vos périodes creuses en opportunités de voyage."
    },
    "slogan7": {
      "title": "Faites une pause,",
      "highlight": "évitez l'épuisement",
      "subtitle": "Soufflez entre deux périodes d'accueil en échangeant votre logement."
    },
    "slogan8": {
      "title": "L'esprit du voyage,",
      "highlight": "le vrai",
      "subtitle": "Rencontrez d'autres hôtes et découvrez de nouveaux lieux à coût réduit."
    },
    "slogan9": {
      "title": "100% fabrique en France",
      "highlight": "(Picardie)",
      "subtitle": "Pas la Silicon Valley, mais la Vallée de la Haute Somme. Une plateforme artisanale, humaine et fière de ses racines."
    }
  }
};
